/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Logo_AltInputs */

const en_onboarding_logo_alt = /** @type {(inputs: Onboarding_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening logo`)
};

const es_onboarding_logo_alt = /** @type {(inputs: Onboarding_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de Listening`)
};

/**
* | output |
* | --- |
* | "Listening logo" |
*
* @param {Onboarding_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_logo_alt = /** @type {((inputs?: Onboarding_Logo_AltInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Logo_AltInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_logo_alt(inputs)
	return en_onboarding_logo_alt(inputs)
});